import script from "./mainHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainHeader.vue?vue&type=script&setup=true&lang=ts"

import "./mainHeader.vue?vue&type=style&index=0&id=73e6dd6e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e6dd6e"]])

export default __exports__